(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["cc-main-404"]) return;
  try {
    
    var s = document.createElement( 'script' );
    s.setAttribute( 'src', 'https://apps.collenandclare.com/handle404/404.js?path='+window.location.pathname );
    document.body.appendChild( s );

  } catch(e) { console.error(e); }
})();
})();
